import { useLocationStore } from '@global-store/stores/location'

import { type Locale, defaultLocale } from '@fond-of/locale'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Translations = Partial<Record<Locale, any>>

export const translate = (
  translations: Translations,
  term: string,
  props: Record<string, string> = {}
) => {
  const locationStore = useLocationStore()
  let translation = getTranslation(
    translations,
    term,
    locationStore.currentLocale
  )

  if (typeof translation === 'undefined') {
    translation = getTranslation(translations, term, defaultLocale)
  }

  Object.entries(props).forEach(
    ([key, value]) => (translation = translation?.replaceAll(`{${key}}`, value))
  )

  return translation ?? ''
}

const getTranslation = (
  translations: Translations,
  term: string,
  locale: Locale
) => {
  let result = undefined

  if (term.toString().includes('.')) {
    const arr = term.split('.')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let path: any = undefined

    for (const item of arr) {
      path = !path ? translations[locale]?.[item] : path[item]
    }

    result = path
  }

  if (!result) {
    result = translations[locale]?.[term]
  }

  return result
}
